export default __webpack_public_path__ + "static/readin-2537f7eda1f8fdd5c05808431e1ec224.png";